export default __webpack_public_path__ + "static/5-9d34c8c00078bbff7aaffd73c4b0aa0c.jpg";